<app-configuration-page
  title="PayBright"
  description="Connect your PayBright account and terminal, then check the connection before switching it on."
  [breadcrumbs]="[{ label: 'Integrations' }, { label: 'PayBright' }]">

  <div class="row">
    <!-- Main column: settings -->
    <div class="col-lg-8 col-12 paybright-main-col">
      <app-form-paybright-settings></app-form-paybright-settings>
    </div>

    <!-- Sidebar: setup guide -->
    <div class="col-lg-4 col-12">
      <app-setup-guide
        heading="Connecting your account"
        [steps]="setupSteps"
        footer="You’ll find your source key, PIN, and terminal serial number in your PayBright account.">
      </app-setup-guide>
    </div>
  </div>

</app-configuration-page>
